// Стор для feature flags
// import { useFeatureFlagsStore } from '@/store/featureFlags';
// При переходе между страницами с бэка запрашиваем список флагов
// В компоненте используем геттер
// setup () {
//   const featureFlagsStore = useFeatureFlagsStore();
//   const isFiredAgent = computed(() => featureFlagsStore.isFiredAgent()),
//   return {
//     isFiredAgent
//   };
// }
// Использовать
// v-if = isFiredAgent

import { defineStore } from 'pinia';
import { ref } from 'vue';

import { useClientApi } from '@/plugins/api/lk';
import { decorateApiActions } from '@/shared/lib';

type Flags = Record<string, boolean>;

/* список флагов которые используются в проекте */
export const FLAGS = {
  userRealIPAddress: 'del002-1011_f', // Получаем реальный адрес для подстановки в сентри
  support: 'strana_lk-4438_f', // ФОС
  firedAgent: 'del002-39_f', // увольнение агента
  closedSales: 'del002-353_f', // закрытые продажи
  ogrnField: 'del002-795_f', // поле ОГРН при регистрации
  dealCatalog: 'del002-884_f', // каталог из сделки
  managerCollection: 'del002-791_f', // подборки от менеджера КП релиз 3
  acceptPrivate: 'del002-681_f', //  акцептование приватных документов
  logo20: 'del002-983_f', // Логотип 20 лет заботы
  managerCollection4: 'del002-952_f', //  подборки от менеджера КП релиз 4
  loyaltyNsk: 'del002-1005_f', // Условия ПЛ для НСК
  headerNew: 'del002-1024_f', // Новый хедер
  brokerLoyaltyStars: 'broker-loyalty-stars', // баннер баланса в годовом рейтинге брокеров на ПЛ
} as const;

type TFlags = typeof FLAGS;
type TFlagsValues = TFlags[keyof TFlags];
const flags: Array<TFlagsValues> = Object.values(FLAGS);

export const useFeatureFlagsStore = defineStore('featureFlagsBroker', () => {
  const featureFlags = ref<Flags>({});

  async function getFlags (): Promise<void> {
    const url = 'api/feature-flags';

    if (!flags.length) {
      return;
    }

    const {
      data,
    } = await useClientApi().get(url, {
      params: {
        feature_flag: flags,
      },
    });

    featureFlags.value = {
      ...data,
    };
  }

  /**
   * Использовать вместе с константой FLAGS из этого же файла
   */
  function isEnabledFlag (flag: TFlagsValues): boolean {
    return Boolean(featureFlags.value[flag]);
  }

  return {
    featureFlags,
    isEnabledFlag,
    ...decorateApiActions({ getFlags }, 'featureFlags.ts'),
    isUserRealIPAddress: () => isEnabledFlag(FLAGS.userRealIPAddress),
    isFiredAgent: () => isEnabledFlag(FLAGS.firedAgent),
    hasClosedSalesFlag: () => isEnabledFlag(FLAGS.closedSales),
    isOgrnFlag: () => isEnabledFlag(FLAGS.ogrnField),
    isDealCatalogFlag: () => isEnabledFlag(FLAGS.dealCatalog),
    isManagerCollectionFlag: () => isEnabledFlag(FLAGS.managerCollection),
    isManagerCollection4Flag: () => isEnabledFlag(FLAGS.managerCollection4),
    isAcceptPrivateFlag: () => isEnabledFlag(FLAGS.acceptPrivate),
    isLogo20: () => isEnabledFlag(FLAGS.logo20),
    isLoyaltyNsk: () => isEnabledFlag(FLAGS.loyaltyNsk),
    isHeaderNew: () => isEnabledFlag(FLAGS.headerNew),
    isBrokerLoyaltyStars: () => isEnabledFlag(FLAGS.brokerLoyaltyStars),
  };
});
